module.exports = __webpack_public_path__ + "img/RegFees-10-clinicalvisits.66a7b000.svg";